import { defineMessages } from 'react-intl';

export const scope = 'app.components.shared.datepicker.date_input_box';

export default defineMessages({
  invalid_date: {
    id: `${scope}.invalid_date`,
    defaultMessage: 'Enter valid date',
  },
  calendar_icon: {
    id: `${scope}.calendar_icon`,
    defaultMessage: 'Calendar Icon',
  },
  day_placeholder: {
    id: `${scope}.day_placeholder`,
    defaultMessage: 'DD',
  },
  month_placeholder: {
    id: `${scope}.month_placeholder`,
    defaultMessage: 'MM',
  },
  year_placeholder: {
    id: `${scope}.year_placeholder`,
    defaultMessage: 'YYYY',
  },
});
